import { Routes } from '../routes';

export const avoidBannerRoutes = [
  Routes.Setting_Billing_Upgrade_Email_Outreach_Plan as string,
];
